import * as actionTypes from "../actions/actionTypes";
import { updateObject } from "../../utils/updateObject";
import { welcomeStep } from "../../utils/daniUtils";
import { randomId } from "../../utils/stringUtils";
import { isEmpty } from "lodash";

const initialState = {
  opened: false,
  minimized: true,
  showHelpText: true,
  currentStep: {},
  previousStep: {},
  renderedSteps: [],
  selectedChart: {},
  searchResultPage: 0,
  searchedTerm: "",
  searchResults: [],
  selectedToolkit: {},
  showDrillDownModal: false,
  selectedKpi: "",
  assistantSessionMessages: [],
  apiValue: "",
  loadingSearchResult: false,
  latestStepId: null,
  historyChats: {},
  currentChatId: null,
  extractedText: "",
  fileMultiplePartsResponse: {
    text: "",
    changesMade: "",
  },
  engageActionClick:false
};

export default function(state = initialState, action) {
  let renderedSteps = null;
  let previousStep = null;
  let currentStep = null;
  let chatsStored = { ...state.historyChats };
  switch (action.type) {
    case actionTypes.OPEN_DANI:
      return {
        ...state,
        opened: true,
        minimized: false,
        loadingSearchResult: false,
      };
    case actionTypes.ADD_DANI_ASSISTANT_SESSION_MESSAGES:
      return {
        ...state,
        assistantSessionMessages: [
          ...state.assistantSessionMessages,
          ...action.payload,
        ],
      };
    case actionTypes.UPDATE_DANI_ASSISTANT_SESSION_MESSAGES:
      return {
        ...state,
        assistantSessionMessages: [...action.payload],
      };
    case actionTypes.CLOSE_DANI:
      return {
        ...state,
        opened: false,
        minimized: true,
        //assistantSessionMessages: [],
        loadingSearchResult: false,
        //currentStep: {},
        //previousStep: {},
        //renderedSteps: [],
        //selectedChart: {},
      };
    case actionTypes.CLOSE_DANI_HELP_TEXT:
      return { ...state, showHelpText: false };
    case actionTypes.TRIGGER_NEXT_STEP:
      const { nextStep } = action.val;
      renderedSteps = Array.from(state.renderedSteps);
      previousStep = renderedSteps[renderedSteps.length - 1];
      if (nextStep) {
        renderedSteps.push(nextStep);
      }
      if (!isEmpty(chatsStored[state.currentChatId])) {
        chatsStored[state.currentChatId].messages = [...renderedSteps];
        chatsStored[state.currentChatId].time = new Date();
      }

      if (nextStep && !nextStep.timeStamp) {
        nextStep["timeStamp"] = new Date();
      }

      return {
        ...state,
        renderedSteps,
        historyChats: chatsStored,
        currentStep: nextStep,
        previousStep: previousStep,
      };
    case actionTypes.OPTION_SELECTED:
      renderedSteps = Array.from(state.renderedSteps);
      renderedSteps.pop();
      renderedSteps.push({ ...action.val, timeStamp: new Date() });
      currentStep = action.val;
      if (!isEmpty(chatsStored[state.currentChatId])) {
        chatsStored[state.currentChatId].messages = [...renderedSteps];
        chatsStored[state.currentChatId].time = new Date();
      }
      return {
        ...state,
        renderedSteps,
        historyChats: chatsStored,
        currentStep: currentStep,
        apiValue: action.val.apiValue,
      };
    case actionTypes.CHART_SELECTED:
      const selectedChart = action.val.chart;
      const nStep = action.val.nextStep;

      renderedSteps = Array.from(state.renderedSteps);
      renderedSteps.push(nStep);
      console.log(nStep, renderedSteps);
      if (!isEmpty(chatsStored[state.currentChatId])) {
        chatsStored[state.currentChatId].messages = [...renderedSteps];
        chatsStored[state.currentChatId].time = new Date();
      }
      return {
        ...state,
        selectedChart: selectedChart,
        renderedSteps,
        opened: true,
        minimized: false,
        historyChats: chatsStored,
      };
    case actionTypes.CHART_UNSELECTED:
      renderedSteps = Array.from(state.renderedSteps);
      renderedSteps.push(action.val);
      if (!isEmpty(chatsStored[state.currentChatId])) {
        chatsStored[state.currentChatId].messages = [...renderedSteps];
        chatsStored[state.currentChatId].time = new Date();
      }
      return {
        ...state,
        selectedChart: {},
        renderedSteps,
        historyChats: chatsStored,
      };
    case actionTypes.FETCH_RECOMMENDED_TOOLS:
      renderedSteps = Array.from(state.renderedSteps);
      renderedSteps.push(action.val);
      currentStep = action.val;
      if (!isEmpty(chatsStored[state.currentChatId])) {
        chatsStored[state.currentChatId].messages = [...renderedSteps];
        chatsStored[state.currentChatId].time = new Date();
      }
      return {
        ...state,
        renderedSteps,
        currentStep: currentStep,
        historyChats: chatsStored,
      };
    case actionTypes.SET_CURRENT_STEP:
      // console.log("itsUnique", state.renderedSteps);
      renderedSteps = Array.from(state.renderedSteps);
      const stepToAdd = { ...action.val };
      if (!stepToAdd.timeStamp) {
        stepToAdd["timeStamp"] = new Date();
      }
      renderedSteps.push(stepToAdd);
      currentStep = action.val;
      // console
      if (!isEmpty(chatsStored[state.currentChatId])) {
        chatsStored[state.currentChatId].messages = [...renderedSteps];
        chatsStored[state.currentChatId].time = new Date();
      }
      return {
        ...state,
        renderedSteps,
        currentStep: currentStep,
        historyChats: chatsStored,
      };
    case actionTypes.SEARCH_RESULTS_FETCHED:
      renderedSteps = Array.from(state.renderedSteps);
      const steps = renderedSteps.concat(action.val.nextStep);
      const searchResults = action.val.searchResults;
      if (!isEmpty(chatsStored[state.currentChatId])) {
        chatsStored[state.currentChatId].messages = [...steps];
        chatsStored[state.currentChatId].time = new Date();
      }
      return {
        ...state,
        renderedSteps: steps,
        searchedTerm: action.val.searchedTerm,
        searchResultPage: 0,
        searchResults: searchResults,
        latestStepId: action.val.latestStepId,
        historyChats: chatsStored,
      };
    case actionTypes.MORE_SEARCH_RESULTS_FETCHED:
      renderedSteps = Array.from(state.renderedSteps);
      const moreSteps = renderedSteps.concat(action.val.nextStep);
      if (!isEmpty(chatsStored[state.currentChatId])) {
        chatsStored[state.currentChatId].messages = [...moreSteps];
      }
      return {
        ...state,
        renderedSteps: moreSteps,
        searchResultPage: action.val.page,
        historyChats: chatsStored,
      };
    case actionTypes.TOOLKIT_SELECTED:
      //const selectedChart = action.val.chart;
      renderedSteps = Array.from(state.renderedSteps);
      renderedSteps.push(action.val);
      if (!isEmpty(chatsStored[state.currentChatId])) {
        chatsStored[state.currentChatId].messages = [...renderedSteps];
        chatsStored[state.currentChatId].time = new Date();
      }
      return {
        ...state,
        currentStep: action.val,
        selectedToolkit: {},
        // selectedChart : {},
        renderedSteps,
        historyChats: chatsStored,
      };
    case actionTypes.DRILLDOWN_CHART:
      return { ...state, showDrillDownModal: true };
    case actionTypes.CLOSE_DRILLDOWN_MODAL:
      renderedSteps = Array.from(state.renderedSteps);
      renderedSteps.push(action.val);
      if (!isEmpty(chatsStored[state.currentChatId])) {
        chatsStored[state.currentChatId].messages = [...renderedSteps];
        chatsStored[state.currentChatId].time = new Date();
      }
      return {
        ...state,
        showDrillDownModal: false,
        renderedSteps,
        historyChats: chatsStored,
      };
    case actionTypes.SELECT_KPI_FOR_CHART:
      renderedSteps = Array.from(state.renderedSteps);
      renderedSteps.push(action.val);
      if (!isEmpty(chatsStored[state.currentChatId])) {
        chatsStored[state.currentChatId].messages = [...renderedSteps];
        chatsStored[state.currentChatId].time = new Date();
      }
      return {
        ...state,
        renderedSteps,
        currentStep: action.val,
        historyChats: chatsStored,
      };
    case actionTypes.MINIMIZE_DANI:
      return { ...state, minimized: true, showHelpText: true };
    case actionTypes.MAXIMIZE_DANI:
      return { ...state, minimized: false, showHelpText: false };
    case actionTypes.RECOMMENDED_TOOLKIT_OPTION_SELECTED:
      renderedSteps = Array.from(state.renderedSteps);
      previousStep = renderedSteps[renderedSteps.length - 1];
      if (action.val) {
        renderedSteps.push(action.val);
      }
      if (!isEmpty(chatsStored[state.currentChatId])) {
        chatsStored[state.currentChatId].messages = [...renderedSteps];
        chatsStored[state.currentChatId].time = new Date();
      }
      return {
        ...state,
        renderedSteps,
        currentStep: action.val,
        previousStep: previousStep,
        selectedChart: {},
        historyChats: chatsStored,
      };
    case actionTypes.UNSELECT_CHART_WITH_NO_FEEDBACK:
      return { ...state, selectedChart: {} };
    case actionTypes.DANI_CLEAR_STEPS:
      if (!isEmpty(chatsStored[state.currentChatId])) {
        chatsStored[state.currentChatId].messages = [...action.val];
      }
      return {
        ...state,
        currentStep: action.val[1],
        previousStep: action.val[0],
        renderedSteps: action.val,
        selectedChart: {},
        searchResultPage: 0,
        searchedTerm: "",
        searchResults: [],
        selectedToolkit: {},
        selectedKpi: "",
        historyChats: chatsStored,
      };

    case actionTypes.DANI_UPDATE_STEP:
      renderedSteps = Array.from(state.renderedSteps);

      let stepToUpdateIndex = renderedSteps.findIndex(
        x => x.id === action.val.id
      );

      if (stepToUpdateIndex >= 0) {
        renderedSteps[stepToUpdateIndex] = { ...action.val };
      }
      if (!isEmpty(chatsStored[state.currentChatId])) {
        chatsStored[state.currentChatId].messages = [...renderedSteps];
        chatsStored[state.currentChatId].time = new Date();
      }
      return {
        ...state,
        renderedSteps,
        historyChats: chatsStored,
      };

    case actionTypes.FETCH_RESULTS_LOADING:
      return {
        ...state,
        loadingSearchResult: action.payload,
      };

    case actionTypes.ADD_CHATS_TO_HISTORY:
      const historyChatsObject = { ...state.historyChats };
      const lastIndex = randomId(10);

      historyChatsObject[lastIndex] = {
        time: new Date(),
        messages: [],
      };

      return {
        ...state,
        historyChats: { ...historyChatsObject },
        currentChatId: lastIndex,
      };

    case actionTypes.SET_LATEST_STEP_ID:
      return {
        ...state,
        latestStepId: action.payload,
      };

    case actionTypes.SET_DANI_CURRENT_CHAT_ID:
      return {
        ...state,
        currentChatId: action.payload,
      };

    case actionTypes.SET_DANI_EXTRACTED_TEXT:
      return {
        ...state,
        extractedText: action.payload,
      };

    case actionTypes.DELETE_DANI_HISTORY_CHAT:
      let chats = { ...state.historyChats };

      delete chats[action.payload];
      return {
        ...state,
        historyChats: { ...chats },
      };

    case actionTypes.DANI_SET_FILE_MULTIPART_RESPONSE:
      const data = state.fileMultiplePartsResponse
        ? { ...state.fileMultiplePartsResponse }
        : {
            text: "",
            changesMade: "",
          };
      return {
        ...state,
        fileMultiplePartsResponse: {
          text: data.text + action.payload.text,
          changesMade: data.changesMade + action.payload.changesMade,
        },
      };
    case actionTypes.DANI_RESET_FILE_MULTIPART_RESPONSE:
      return {
        ...state,
        fileMultiplePartsResponse: {
          text: "",
          changesMade: "",
        },
      };
    case actionTypes.DANI_SET_ENGAGE_ACTION_CLICK:
      console.log("Setting",action.payload)
      return {
        ...state,
        engageActionClick:action.payload
      };
    default:
      break;
  }
  return state;
}
